module.exports = __webpack_public_path__ + "img/img0.be2fdd2e.jpg";